// extracted by mini-css-extract-plugin
export default {"checkbox":"MGInputCheckbox_checkbox__7rOPl","input":"MGInputCheckbox_input__pbLqq","visual":"MGInputCheckbox_visual__C2isL","icon":"MGInputCheckbox_icon__rViuy"};